var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom_headline-image"},[_c('div',{staticClass:"custom_headline-inner_text"},[_vm._v("\n    "+_vm._s(_vm.customTitle)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }